
export const LOGGED_USER_INFO = "LOGGED_USER_INFO";
export const LOGGED_USER_INFO_RELOAD = "LOGGED_USER_INFO_RELOAD";
